import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/config/doctorConfig";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";
import { BlogCard } from "@/components/BlogSection";
import { SectionHeading } from "@/components/motion";
import { blogPosts } from "@/data/blogPosts";

export default function BlogListPage() {
  return (
    <>
      <Helmet>
        <title>Health Blog | Dr. Suyash Bhadoriya — Physician in Bhopal</title>
        <meta
          name="description"
          content="Patient education articles by Dr. Suyash Bhadoriya, MD (Internal Medicine), Bhopal — diabetes, blood pressure, thyroid, fever, cholesterol, fatty liver and preventive health."
        />
        <link rel="canonical" href={`${SITE_URL}/blog`} />
        <meta property="og:url" content={`${SITE_URL}/blog`} />
      </Helmet>
      <Header />
      <main className="pt-28 lg:pt-36 pb-20 bg-background min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            number="Blog"
            eyebrow="Patient Education"
            title="Medical Articles for Patients"
            sub="Medically responsible, easy-to-read articles on common health concerns. Educational only — not a substitute for consultation."
          />
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-list-grid">
            {blogPosts.map((post, i) => (
              <BlogCard key={post.slug} post={post} index={i} />
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <MobileActionBar />
    </>
  );
}
